import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../context/AppContext";
import { MIN_PROPERTY_HEIGHT, MIN_PROPERTY_WIDTH } from "@utils/constant";
import NumberInput from "./shared/NumberInput";

function getScaledHeight(selectedObject: fabric.Object | null) {
  return Math.round(
    (selectedObject?.height || MIN_PROPERTY_HEIGHT) *
      (selectedObject?.scaleY || 1)
  );
}

function Height() {
  const {
    canvas,
    selectedObject,
    coreHandler,
    isWidthHeightProportionalScaled,
  } = useContext(AppContext);
  const [height, setHeight] = useState(getScaledHeight(selectedObject));

  // triggered by clicking layers
  useEffect(() => {
    setHeight(getScaledHeight(selectedObject));
  }, [selectedObject]);

  // triggered by fabric controls
  useEffect(() => {
    function onModified(event: any) {
      const newHeight = getScaledHeight(selectedObject);
      setHeight(newHeight);
    }

    coreHandler?.eventHandler.on("object:modified", onModified);
    return () => {
      coreHandler?.eventHandler.off("object:modified", onModified);
    };
  }, [coreHandler, selectedObject]);

  function onChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newHeight = Math.max(
      MIN_PROPERTY_HEIGHT,
      parseInt(event.target.value, 10)
    );

    if (!selectedObject) return;

    const newScaleY =
      newHeight / (selectedObject.height || MIN_PROPERTY_HEIGHT);

    if (isWidthHeightProportionalScaled) {
      // Calculate proportional width to maintain aspect ratio
      const currentAspectRatio =
        (selectedObject.width || MIN_PROPERTY_WIDTH) /
        (selectedObject.height || MIN_PROPERTY_HEIGHT);
      const newWidth = newHeight * currentAspectRatio;
      const newScaleX = newWidth / (selectedObject.width || MIN_PROPERTY_WIDTH);

      // Ensure minimum width constraint
      const constrainedScaleX = Math.max(
        MIN_PROPERTY_WIDTH / (selectedObject.width || MIN_PROPERTY_WIDTH),
        newScaleX
      );

      selectedObject.set({
        scaleX: constrainedScaleX,
        scaleY: newScaleY,
      });
    } else {
      selectedObject.set("scaleY", newScaleY);
    }

    setHeight(newHeight);
    // @ts-ignore - TODO - fix this later
    coreHandler?.eventHandler.modified({ target: selectedObject });
    canvas?.renderAll();
  }

  return (
    <NumberInput onChange={onChange} value={height} min={MIN_PROPERTY_HEIGHT} />
  );
}

export default Height;
